import React from 'react';
import { theme } from 'antd';

import AnnouncementBanner from '~components/AnnouncementBanner';
import { isImpersonatedSession } from '~features/auth';

import useTrackDashboardV3Event from '../useTrackDashboardV3Event';
import { CRAWLER_PICKER_ANNOUNCEMENT_STRINGS } from './CrawlerPickerAnnouncementRules';
import { useCrawlerPickerAnnouncement } from './useCrawlerPickerAnnouncement';

const ILLUSTRATION = { src: '/assets/img/dashboard/crawler-picker-banner.svg', width: 336, height: 140 };

function CrawlerPickerAnnouncement() {
  const { token } = theme.useToken();
  const { visible, dismiss } = useCrawlerPickerAnnouncement();
  const [closedThisVisit, setClosedThisVisit] = React.useState(false);
  const track = useTrackDashboardV3Event();
  const isImpersonating = isImpersonatedSession();

  const viewedTracked = React.useRef(false);
  React.useEffect(() => {
    if (!visible || viewedTracked.current) return;
    viewedTracked.current = true;
    if (!isImpersonating) track('CrawlerPickerBannerViewed', {});
  }, [visible, isImpersonating, track]);

  if (!visible || closedThisVisit) return null;

  const handleDismiss = () => {
    setClosedThisVisit(true);
    if (isImpersonating) return;
    track('CrawlerPickerBannerDismissed', {});
    dismiss();
  };

  return (
    <div style={{ marginBottom: token.margin }}>
      <AnnouncementBanner
        title={CRAWLER_PICKER_ANNOUNCEMENT_STRINGS.title}
        body={CRAWLER_PICKER_ANNOUNCEMENT_STRINGS.body}
        illustration={ILLUSTRATION}
        onDismiss={handleDismiss}
      />
    </div>
  );
}

export default CrawlerPickerAnnouncement;
